var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconIndustrial40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18671)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25781 14.542L18.8707 9.50269V14.542L31.1288 9.50269V14.542V31.4382H7.25781V14.542Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 18.5349H16.2905V31.4381H35.0002V18.5349Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.129 22.7285C12.9544 22.7285 14.5934 23.5265 15.7162 24.7926C16.1073 24.7083 16.5159 24.664 16.9355 24.664C19.9641 24.664 22.4194 26.9748 22.4194 29.8253C22.4194 30.3887 22.3234 30.931 22.1461 31.4386L5.56822 31.4383C5.20357 30.6539 5 29.7795 5 28.8575C5 25.4726 7.74406 22.7285 11.129 22.7285Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconIndustrial40);
export default __webpack_public_path__ + "static/media/pictogramBeaconIndustrial40.29f0eb69d43cf6ce05b74f450cdfc2c4.svg";
export { ForwardRef as ReactComponent };